import { Link } from "react-router-dom";

export function MarketingFooter() {
  return (
    <footer className="border-t-4 border-[#A43032] bg-[#010101] text-stone-100">
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-4 py-12 sm:flex-row sm:items-start sm:justify-between sm:px-6">
        <div>
          <div className="flex items-center gap-3">
            <span className="inline-flex rounded-lg bg-white p-1.5 shadow-sm">
              <img src="/raguia.webp" alt="" className="h-8 w-auto object-contain" aria-hidden />
            </span>
            <span className="font-heading font-bold tracking-tight text-white">Raguia</span>
          </div>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-stone-300">
            Assistant documentaire B2B — hébergé en France, conçu pour les équipes qui
            veulent livrer de la valeur sans complexité d’infra.
          </p>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="font-semibold text-white">Produit</span>
          <Link to="/valeurs" className="text-stone-300 hover:text-white">
            Nos valeurs
          </Link>
          <Link to="/fonctionnalites" className="text-stone-300 hover:text-white">
            Fonctionnalités
          </Link>
          <Link to="/tarifs" className="text-stone-300 hover:text-white">
            Tarifs
          </Link>
          <Link to="/blog" className="text-stone-300 hover:text-white">
            Blog
          </Link>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="font-semibold text-white">Secteurs</span>
          <Link to="/secteurs/rh" className="text-stone-300 hover:text-white">
            Ressources Humaines
          </Link>
          <Link to="/secteurs/avocats" className="text-stone-300 hover:text-white">
            Avocats
          </Link>
          <Link to="/secteurs/notaires" className="text-stone-300 hover:text-white">
            Notaires
          </Link>
          <Link to="/secteurs/comptables" className="text-stone-300 hover:text-white">
            Experts-Comptables
          </Link>
          <Link to="/secteurs/immobilier" className="text-stone-300 hover:text-white">
            Immobilier
          </Link>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="font-semibold text-white">Comparatifs</span>
          <Link to="/comparatif" className="text-stone-300 hover:text-white">
            Toutes les alternatives
          </Link>
          <Link to="/vs/dust" className="text-stone-300 hover:text-white">
            Raguia vs Dust
          </Link>
          <Link to="/vs/chatgpt-enterprise" className="text-stone-300 hover:text-white">
            Raguia vs ChatGPT
          </Link>
        </div>
        <div className="flex flex-col gap-2 text-sm">
          <span className="font-semibold text-white">Légal &amp; infos</span>
          <Link to="/mentions-legales" className="text-stone-300 hover:text-white">
            Mentions légales
          </Link>
          <Link to="/confidentialite" className="text-stone-300 hover:text-white">
            Politique de confidentialité
          </Link>
          <Link to="/contact" className="text-stone-300 hover:text-white">
            Contact
          </Link>
          <a
            href="https://status.valentin-fiess.fr/status/raguia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-300 hover:text-white"
          >
            Statut du service
          </a>
        </div>
      </div>
      <div className="border-t border-white/10 bg-black py-6 text-center text-sm text-stone-400">
        <p className="flex items-center justify-center gap-4 flex-wrap">
          <span>
            Créé en France 🇫🇷 par{" "}
            <a
              href="https://valentin-fiess.fr"
              className="font-medium text-[#A43032] hover:underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Valentin Fiess
            </a>
          </span>
          <span className="text-stone-600">·</span>
          <a
            href="https://status.valentin-fiess.fr/status/raguia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-stone-400 hover:text-white transition-colors"
          >
            Statut du service
          </a>
        </p>
      </div>
    </footer>
  );
}
